import HttpClient from '@/common/boot/HttpClient'

////////////////////////////////////////////////
const salvarUsuario = async ({ commit }, payload) => {

  commit('BUSCANDO', true);

  return await HttpClient.post('/app/perfis', payload).then(response => {
    commit('INSERIR_USUARIO', response.data.data)
    return response;
  })
  .finally( () => {
    commit('BUSCANDO', false);
  });
}

//////////////////////////////////////////////////////////
const recuperarUsuario = ({ commit, state }, payload) => {

  const usuario = state.items.filter(usuario => usuario.id === payload.id)

  if(usuario.length) {
    commit('INSERIR_USUARIO_SELECIONADO', ...usuario)
    return true
  }

  return false
}

////////////////////////////////////////////////////
const atualizarUsuario = async ({ commit }, payload) => {
  commit('BUSCANDO', true);

  return await HttpClient.put(`/app/perfis/${payload.id}`, payload).then(response => {
    commit('ATUALIZAR_USUARIO', payload)
    return response;
  })
  .finally( () => {
    commit('BUSCANDO', false);
  })
}

////////////////////////////////////////////////////
const deletarUsuario = async ({ commit }, payload) => {
  commit('BUSCANDO', true);

  return await HttpClient.delete(`/app/perfis/${payload.id}`).then(response => {
    commit('DELETAR_USUARIO', payload)
    return response;
  })
  .finally( () => {
    commit('BUSCANDO', false);
  })

}

const listarPerfis = async ({commit}) => {
  commit('BUSCANDO', true);

  return await HttpClient.get(`/app/rotas`).then(response => {
    commit('INSERIR_LISTA_PERFIS', response.data.data)
    return response;
  })
  .finally( () => {
    commit('BUSCANDO', false);
  })
}

const recuperarPerfilComRotas = async ({ commit }, payload) => {
  commit('BUSCANDO', true);

  return await HttpClient.get(`/app/perfis/${payload}/associar-rotas`, payload).then(response => {
    commit('INSERIR_USUARIO_SELECIONADO', response.data.data)
    return response;
  })
  .finally( () => {
    commit('BUSCANDO', false);
  });
}

const associarRotaAoPerfil = ({ commit }, payload) => {
  commit('BUSCANDO', true);

  HttpClient.post(`/app/perfis/${payload.perfilId}/associar-rotas`, payload).then(response => {
    return response;
  })
  .finally( () => {
    commit('BUSCANDO', false);
  });
}

export {
  salvarUsuario,
  recuperarUsuario,
  atualizarUsuario,
  deletarUsuario,
  listarPerfis,
  recuperarPerfilComRotas,
  associarRotaAoPerfil
}